import _uniqBy from 'lodash/uniqBy'

import referentialLocaleMessage from '../services/referentialLocaleMessage'

const state = {
  currentReferential: null,
}

const getters = {
  currentReferential: (state) => state.currentReferential,
  familiesAndSubFamilies: (state) => {
    const families = {}
    for (const [key, value] of Object.entries(state.currentReferential)) {
      families[key] = Object.keys(value.subFamilies)
    }
    return families
  },
  availableAssetFields: (state) => {
    const fields = []

    if (state.currentReferential) {
      for (const [family, familyAttr] of Object.entries(
        state.currentReferential,
      )) {
        if (
          familyAttr.subFamilies &&
          Object.values(familyAttr.subFamilies).length
        ) {
          for (const [subFamily, subFamilyAttr] of Object.entries(
            familyAttr.subFamilies,
          )) {
            if (subFamilyAttr.attributes && subFamilyAttr.attributes.length) {
              for (const attr of subFamilyAttr.attributes) {
                fields.push({
                  name: attr.name,
                  path: `${attr.attributeType}.${attr.name}`,
                  location: attr.attributeType,
                  type: attr.valueType,
                  family,
                  subFamily,
                  order: 999,
                  sortable: true,
                })
              }
            }
          }
        }
      }
    }

    return _uniqBy(fields, 'path')
  },
  availableAssetDateFields: (state) => {
    const fields = []

    if (state.currentReferential) {
      for (const [family, familyAttr] of Object.entries(
        state.currentReferential,
      )) {
        if (
          familyAttr.subFamilies &&
          Object.values(familyAttr.subFamilies).length
        ) {
          for (const [subFamily, subFamilyAttr] of Object.entries(
            familyAttr.subFamilies,
          )) {
            if (subFamilyAttr.attributes && subFamilyAttr.attributes.length) {
              for (const attr of subFamilyAttr.attributes) {
                if (attr.valueType === 'date') {
                  fields.push({
                    name: attr.name,
                    path: `${attr.attributeType}.${attr.name}`,
                    location: attr.attributeType,
                    type: attr.valueType,
                    family,
                    subFamily,
                    order: 999,
                    sortable: true,
                  })
                }
              }
            }
          }
        }
      }
    }

    return _uniqBy(fields, 'path')
  },
  commonAttributesByFamilyAndSub: (state) => (selectedFamiliesAndSub) => {
    const attributes = []
    let cpt = 0
    const selectedFamilies = Object.keys(selectedFamiliesAndSub)

    for (const family of selectedFamilies) {
      if (state.currentReferential.hasOwnProperty(family)) {
        const selectedSubFamilies = selectedFamiliesAndSub[family]

        for (const subFamily of selectedSubFamilies) {
          cpt++
          if (
            state.currentReferential[family].subFamilies.hasOwnProperty(
              subFamily,
            ) &&
            state.currentReferential[family].subFamilies[subFamily]
              .attributes &&
            state.currentReferential[family].subFamilies[subFamily].attributes
              .length
          ) {
            for (const attr of state.currentReferential[family].subFamilies[
              subFamily
            ].attributes) {
              attributes.push({
                name: attr.name,
                path: `${attr.attributeType}.${attr.name}`,
                location: attr.attributeType,
                type: attr.valueType,
                allowedValues: attr.allowedValues || null,
                family,
                subFamily,
              })
            }
          }
        }
      }
    }

    if (cpt === 1) {
      return _uniqBy(attributes, 'path')
    }

    const filteredAttributes = attributes.filter((attr, _index) => {
      const isCommonForAll = attributes.filter(
        (a) => a.path === attr.path,
      ).length

      return isCommonForAll === cpt
    })

    return _uniqBy(filteredAttributes, 'path')
  },
}

const actions = {
  FETCH_CURRENT_REFERENTIAL: async ({ commit, rootGetters }, kuzzle) => {
    if (!rootGetters['auth/currentIndex']) {
      return
    }
    let currentReferential = {}
    try {
      const searchResult = await kuzzle.document.search(
        rootGetters['auth/currentIndex'],
        'references',
        {},
      )

      currentReferential = searchResult.hits[0]
      delete currentReferential._source._kuzzle_info

      referentialLocaleMessage.mergeLocalMessage(currentReferential)
    } catch (error) {
      console.error(error)
      throw error
    }

    commit('SET_CURRENT_REFERENTIAL', currentReferential._source)
  },
}

const mutations = {
  SET_CURRENT_REFERENTIAL: (state, referential) => {
    state.currentReferential = referential
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
